export default {
    methods: {
        gettext(text, context) {
            if (window.gettext) {
                if (context) {
                    return window.interpolate(window.gettext(text), context, true);
                }
                return window.gettext(text);
            }
            return text;
        },
        // Also provide _ as an alias for convenience
        _(text, context) {
            return this.gettext(text, context);
        },
    },
};
